export default function getDateAndTimeFromISO(isoString){
    const dateTime = new Date(isoString);
    const date = isoString.substring(0,10).split('-');
    return `${date[0]}-${date[1]}-${date[2]} ${dateTime.getUTCHours()+8}:${dateTime.getUTCMinutes()}`
}
